import React from 'react';
import PropTypes from 'prop-types';
import { combineClassNames } from 'core/css';

const MathBoxGroup = ({ children, ruled = false, className }) => (
  <div
    className={combineClassNames(
      'math-box__group',
      ruled && 'math-box__group--ruled',
      className
    )}>
    {children}
  </div>
);

MathBoxGroup.propTypes = {
  ruled: PropTypes.bool,
};

export default MathBoxGroup;
